/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { LinkListItemFragment } from "@cosmos/hygraph-schema";

import { CosmosLink, CosmosText, CosmosTextVariants, EdsIcon } from "@components/elements";
import { css } from "@panda/css";
import { HStack, VStack } from "@panda/jsx";
import { SystemStyleObject } from "@panda/types";
import { MouseEvent } from "react";

const linkStyle: SystemStyleObject = {
	color: "eds.text.link.primary.default",
};

type LinkProps = LinkListItemFragment & { className?: string };

export type LinkListProps = {
	links?: LinkProps[] | null;
	onClick?: (event: MouseEvent<HTMLAnchorElement>, index: number) => void;
	linkVariant?: CosmosTextVariants;
};

export function LinkList({ links, onClick, linkVariant = "paragraphMD" }: LinkListProps): React.JSX.Element {
	return (
		<VStack className="link-list" gap="eds.dimension.10" alignItems="flex-start">
			{(links || []).map((link, i) => {
				const isRenderable = link.label || link.icon;
				const isNotClickable = !link.href && !onClick;
				if (isNotClickable || !isRenderable) return null;

				let icon = null;
				if (link.icon) {
					icon = <EdsIcon key="link-icon" icon={link.icon} />;
				}

				const children: React.ReactNode[] = [
					<CosmosText
						key="link-element"
						text={link.label || ""}
						color="eds.text.link.primary.default"
						variant={linkVariant || "paragraphMD"}
						className={link.className || ""}
						textCss={css.raw({
							transition: "color token(animations.eds.duration.200) token(animations.eds.easing.easeInOutQuad)",
							_hover: {
								color: "eds.fill.primary.hover",
							},
						})}
					/>,
					icon,
				];

				return (
					<CosmosLink
						key={`link-${link?.id || i}`}
						href={link.href || ""}
						className={css(linkStyle)}
						analytics={{
							eventCategory: "hyperlink",
							eventLabel: link.label || "",
							eventValue: {
								component: "LinkList",
								href: link.href,
							},
						}}
						onClick={(event) => onClick?.(event, i)}
					>
						<HStack gap="eds.dimension.4">{link.iconPosition === "start" ? children.reverse() : children}</HStack>
					</CosmosLink>
				);
			})}
		</VStack>
	);
}
